import React from 'react';
import { X, Mail, AlertCircle } from 'lucide-react';

const TagEmailConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    tagType,
    candidateName 
}) => {
    if (!isOpen) {
        return null;
    }

    const getTagInfo = (tagType) => {
        switch (tagType?.toLowerCase()) {
            case 'rejected':
                return {
                    title: 'Send Rejection Email?',
                    message: `This will send a rejection email to ${candidateName || 'the candidate'} and CC company admins.`,
                    icon: <AlertCircle className="w-6 h-6 text-red-500" />
                };
            case 'selected':
                return {
                    title: 'Send Selection Email?',
                    message: `This will send a selection email to ${candidateName || 'the candidate'} and CC company admins.`,
                    icon: <Mail className="w-6 h-6 text-green-500" />
                };
            case '1-to-1 with manager':
            case '1-to-1 discussion with manager':
                return {
                    title: 'Send Manager Notification?',
                    message: `This will send a notification email to company admins (hiring managers) stating that ${candidateName || 'the candidate'} has been selected for the next round - 1-to-1 discussion with manager.`,
                    icon: <Mail className="w-6 h-6 text-blue-500" />
                };
            default:
                return {
                    title: 'Send Email?',
                    message: `This will send an email notification based on the selected tag.`,
                    icon: <Mail className="w-6 h-6 text-gray-500" />
                };
        }
    };

    const tagInfo = getTagInfo(tagType);

    return (
        <div 
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4"
            style={{ zIndex: 10000 }}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div 
                className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl text-[10.5px]"
                style={{ fontSize: '10.5px' }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start gap-4 mb-4">
                    <div className="flex-shrink-0 mt-1">
                        {tagInfo.icon}
                    </div>
                    <div className="flex-1">
                        <h3 className="text-[10.5px] font-semibold text-gray-900 mb-1.5" style={{ fontSize: '10.5px' }}>
                            {tagInfo.title}
                        </h3>
                        <p className="text-[10.5px] text-gray-600" style={{ fontSize: '10.5px' }}>
                            {tagInfo.message}
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4 text-[10.5px]" style={{ fontSize: '10.5px' }}>
                    <p className="text-[10.5px] text-blue-800" style={{ fontSize: '10.5px' }}>
                        <strong>Note:</strong> Tags have been saved. You can choose to send an email notification or skip it. If you continue, you will be able to review and edit the email content before sending.
                    </p>
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-1.5 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors text-[10.5px]"
                        style={{ fontSize: '10.5px' }}
                    >
                        No
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors shadow text-[10.5px] font-medium"
                        style={{ fontSize: '10.5px' }}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TagEmailConfirmModal;

